export default "/images/4db3d42aefa43160cf352b82c9385087.avif";